// Copiado do Profit (ctsportal-frontend, src/theme/tokens.js @ 79ed6b10) em 04/11/2026; os repos são separados.
// Fonte unica de verdade para as cores derivadas da implementacao (cliente).
//
// Toda cor/derivacao ligada a identidade do cliente deve nascer AQUI. Os
// consumidores (createAppTheme, useThemeColors) sao fachadas finas sobre
// esta funcao. Isso mantem a derivacao centralizada e facilita evoluir para
// novos tokens semanticos (superficies, status, etc.) sem tocar nos ~80
// arquivos que ja consomem useThemeColors().

import {
  whiteColor,
  blackColor,
  blendColors,
} from "assets/jss/material-dashboard-pro-react.js";

// Fallback seguro quando a implementacao nao define uma cor de cliente valida.
export const SAFE_CLIENT_COLOR = "#3C3C3B";

// Cor de conteudo (texto/icone) padrao sobre a cor do cliente crua, usada
// quando a implementacao nao define text_color. Branco puro.
export const DEFAULT_CLIENT_TEXT_COLOR = "#ffffff";

const isValidHex = (value) =>
  typeof value === "string" && /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(value);

// Normaliza um hex; se invalido/ausente devolve o fallback informado.
export const normalizeHex = (value, fallback) =>
  isValidHex(value) ? value : fallback;

// Recebe os inputs crus da implementacao (vindos da sessao / userDetails) e
// devolve o conjunto completo de tokens semanticos de cor do cliente.
//
// Convencao de nomenclatura:
//   clientColor*      -> SUPERFICIES (fundos) derivadas da cor do cliente
//   clientTextColor*  -> "on-color": cor de CONTEUDO (texto/icone) sobre uma
//                        superficie. O sufixo indica sobre QUAL superficie.
export const buildClientColors = ({ color, textColor } = {}) => {
  const clientColor = normalizeHex(color, SAFE_CLIENT_COLOR);
  const clientTextColor = normalizeHex(textColor, DEFAULT_CLIENT_TEXT_COLOR);

  return {
    // --- Superficies ---------------------------------------------------- //
    clientColor,
    clientColorLight: blendColors(whiteColor, clientColor, 0.8),
    clientColorDark: blendColors(blackColor, clientColor, 0.2),
    clientColorTransparent: blendColors(whiteColor, clientColor, 0.9),

    // --- Conteudo sobre superficies (on-color) -------------------------- //
    // Sobre a cor do cliente CRUA: configuravel por implementacao para
    // garantir contraste quando a cor e clara. Default branco puro.
    clientTextColor,
    // Sobre a cor do cliente ESCURECIDA: sempre branco. O escurecimento ja
    // garante contraste, entao a feature de text_color nao se aplica aqui.
    clientTextColorOnDark: DEFAULT_CLIENT_TEXT_COLOR,
  };
};

export default buildClientColors;
